import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlower = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 247,
	height: 256,
	viewBox: "0 0 247 256",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2193_9747)",
		filter: "url(#filter0_dddd_2193_9747)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M147.991 300.995C147.935 300.684 147.906 300.373 147.85 300.062C147.174 296.245 145.652 292.569 143.341 289.317C142.073 287.535 140.551 285.867 138.804 284.397L132.04 278.685C129.673 276.677 127.729 274.358 126.235 271.814C123.473 267.091 122.233 261.662 122.656 256.29C122.712 255.413 122.825 254.537 122.994 253.66C123.276 252.076 123.699 250.493 124.262 248.938C125.305 246.195 126.799 243.565 128.8 241.162C130.8 238.786 133.111 236.835 135.648 235.337C142.524 231.265 150.95 230.53 158.446 233.357C161.208 234.404 163.829 235.902 166.196 237.91C168.563 239.918 170.508 242.236 172.001 244.781C173.298 246.958 174.228 249.305 174.848 251.737C176.172 256.968 175.89 262.539 173.974 267.657C172.931 270.4 171.438 273.058 169.437 275.433L148.019 301.023L147.991 300.995Z",
				fill: "#DBACF5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M44.4258 255.865C44.623 255.611 44.7921 255.356 44.9894 255.102C47.1875 251.935 48.7375 248.231 49.3857 244.3C49.752 242.123 49.8366 239.889 49.6393 237.599L48.8784 228.748C48.5966 225.638 48.8784 222.64 49.6111 219.784C50.9638 214.468 53.951 209.775 58.0091 206.24C58.6854 205.674 59.3618 205.137 60.0945 204.628C61.419 203.695 62.8281 202.875 64.3217 202.196C66.9989 200.98 69.9015 200.189 73.0014 199.906C76.1014 199.623 79.0886 199.906 81.9349 200.641C89.6847 202.649 96.1381 208.106 99.4353 215.402C100.647 218.088 101.436 221 101.718 224.111C102 227.221 101.718 230.219 100.985 233.074C100.365 235.535 99.379 237.853 98.1108 240.002C95.3491 244.64 91.2628 248.372 86.2747 250.634C83.5975 251.85 80.6667 252.642 77.595 252.925L44.4258 255.809V255.865Z",
				fill: "#DBACF5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.99902 150.478C3.30902 150.422 3.61901 150.394 3.929 150.337C7.73345 149.658 11.397 148.131 14.6378 145.813C16.4132 144.54 18.0759 143.013 19.5413 141.26L25.2339 134.474C27.2348 132.099 29.5456 130.148 32.0819 128.649C36.7882 125.878 42.199 124.634 47.5534 125.058C48.427 125.114 49.3006 125.227 50.1742 125.397C51.7524 125.68 53.3305 126.104 54.8805 126.669C57.614 127.716 60.2349 129.214 62.6303 131.222C64.9975 133.23 66.942 135.548 68.4356 138.093C72.4937 144.993 73.2264 153.447 70.4083 160.969C69.3656 163.74 67.872 166.37 65.8711 168.745C63.8703 171.12 61.5594 173.071 59.0231 174.57C56.8531 175.871 54.5141 176.804 52.0905 177.426C46.877 178.755 41.3254 178.472 36.2246 176.55C33.491 175.503 30.842 174.005 28.4748 171.997L2.99902 150.478Z",
				fill: "#DBACF5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M47.9756 46.5617C48.2292 46.7596 48.4828 46.9293 48.7365 47.1272C51.8928 49.3328 55.5845 50.888 59.5017 51.5384C61.6716 51.906 63.8979 51.9908 66.1806 51.7929L75.0013 51.0294C78.1012 50.7467 81.0884 51.0294 83.9347 51.7646C89.2328 53.1219 93.9108 56.1192 97.4335 60.1911C97.9971 60.8697 98.5325 61.5483 99.0398 62.2835C99.9698 63.6125 100.787 65.0264 101.463 66.525C102.675 69.2113 103.464 72.1238 103.746 75.2342C104.028 78.3447 103.746 81.342 103.013 84.1979C101.012 91.974 95.5735 98.4494 88.3028 101.758C85.6256 102.974 82.7229 103.765 79.623 104.048C76.5231 104.331 73.5359 104.048 70.6896 103.313C68.2378 102.691 65.927 101.701 63.7852 100.429C59.1635 97.6576 55.4436 93.5575 53.1891 88.5525C51.9773 85.8663 51.1882 82.9255 50.9064 79.8433L48.0319 46.5617H47.9756Z",
				fill: "#DBACF5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M153.007 4.99506C153.063 5.3061 153.091 5.61714 153.148 5.92819C153.824 9.74553 155.346 13.4215 157.657 16.6733C158.925 18.4547 160.447 20.1231 162.194 21.5935L168.957 27.3053C171.324 29.313 173.269 31.6317 174.763 34.1766C177.524 38.8988 178.764 44.3279 178.342 49.7004C178.285 50.577 178.172 51.4536 178.003 52.3302C177.722 53.9137 177.299 55.4972 176.735 57.0524C175.693 59.7952 174.199 62.4249 172.198 64.8285C170.197 67.232 167.886 69.1548 165.35 70.6534C158.474 74.7253 150.048 75.4605 142.552 72.6328C139.79 71.5866 137.169 70.0879 134.802 68.0803C132.435 66.0726 130.49 63.7539 128.996 61.209C127.7 59.0317 126.77 56.6848 126.15 54.253C124.826 49.0218 125.107 43.4513 127.024 38.3332C128.066 35.5904 129.56 32.9324 131.561 30.5571L153.007 4.99506Z",
				fill: "#DBACF5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M256.573 50.1246C256.375 50.3791 256.206 50.6336 256.009 50.8881C253.811 54.0551 252.261 57.7593 251.613 61.6898C251.246 63.8671 251.162 66.1009 251.359 68.3914L252.12 77.2419C252.402 80.3524 252.12 83.3497 251.387 86.2056C250.035 91.5217 247.047 96.2156 242.989 99.7502C242.313 100.316 241.637 100.853 240.904 101.362C239.579 102.295 238.17 103.115 236.677 103.794C233.999 105.01 231.097 105.801 227.997 106.084C224.897 106.367 221.91 106.084 219.063 105.349C211.314 103.341 204.86 97.8839 201.563 90.5885C200.351 87.9022 199.562 84.9897 199.28 81.8793C198.999 78.7689 199.28 75.7716 200.013 72.9156C200.633 70.4556 201.619 68.1369 202.888 65.9878C205.649 61.3505 209.736 57.6179 214.724 55.3558C217.401 54.1399 220.332 53.3482 223.403 53.0654L256.573 50.1812V50.1246Z",
				fill: "#DBACF5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M297.999 155.512C297.689 155.568 297.379 155.596 297.069 155.653C293.264 156.332 289.601 157.859 286.36 160.177C284.584 161.45 282.922 162.977 281.456 164.73L275.764 171.516C273.763 173.891 271.452 175.843 268.916 177.341C264.209 180.112 258.799 181.357 253.444 180.932C252.571 180.876 251.697 180.763 250.823 180.593C249.245 180.31 247.667 179.886 246.117 179.321C243.383 178.274 240.763 176.776 238.367 174.768C236 172.76 234.056 170.442 232.562 167.897C228.504 160.997 227.771 152.543 230.589 145.021C231.632 142.25 233.126 139.62 235.126 137.245C237.127 134.87 239.438 132.919 241.974 131.42C244.144 130.119 246.483 129.186 248.907 128.564C254.121 127.235 259.672 127.518 264.773 129.441C267.507 130.487 270.156 131.985 272.523 133.993L298.027 155.483L297.999 155.512Z",
				fill: "#DBACF5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M253.022 259.428C252.769 259.23 252.515 259.061 252.262 258.863C249.105 256.657 245.414 255.102 241.496 254.452C239.326 254.084 237.1 253.999 234.817 254.197L225.997 254.961C222.897 255.243 219.91 254.961 217.063 254.226C211.765 252.868 207.087 249.871 203.565 245.799C203.001 245.12 202.466 244.442 201.958 243.707C201.028 242.378 200.211 240.964 199.535 239.465C198.323 236.779 197.534 233.866 197.252 230.756C196.97 227.645 197.252 224.648 197.985 221.792C199.986 214.016 205.425 207.541 212.695 204.232C215.373 203.016 218.275 202.225 221.375 201.942C224.475 201.659 227.462 201.942 230.309 202.677C232.76 203.299 235.071 204.289 237.213 205.561C241.835 208.333 245.554 212.433 247.809 217.438C249.021 220.124 249.81 223.065 250.092 226.147L252.966 259.428H253.022Z",
				fill: "#DBACF5"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
		id: "filter0_dddd_2193_9747",
		x: .540232,
		y: .569232,
		width: 337.783,
		height: 326.489,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 1.96703,
				dy: .983516
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2.21291 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.05 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_2193_9747"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 6.88461,
				dy: 3.44231
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3.93407 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.04 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "effect1_dropShadow_2193_9747",
				result: "effect2_dropShadow_2193_9747"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 15.7363,
				dy: 7.86813
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 5.16346 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.03 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "effect2_dropShadow_2193_9747",
				result: "effect3_dropShadow_2193_9747"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 28.0302,
				dy: 13.7692
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 6.14698 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.01 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "effect3_dropShadow_2193_9747",
				result: "effect4_dropShadow_2193_9747"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect4_dropShadow_2193_9747",
				result: "shape"
			})
		]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2193_9747",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 295,
			height: 296,
			fill: "white",
			transform: "translate(2.99902 4.99506)"
		})
	})] })]
});
export default SvgFlower;
